import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import './styles/global.css';

import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import AmbientBackground from './components/layout/AmbientBackground';
import ScrollToTop from './components/layout/ScrollToTop';

import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import WorkPage from './pages/WorkPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';

function NotFound() {
  return (
    <main style={{ minHeight: '70vh', display: 'grid', placeItems: 'center', textAlign: 'center', padding: '0 24px' }}>
      <div>
        <span className="eyebrow"><span className="dot" />404</span>
        <h1 style={{ marginTop: 18 }}>Page not found.</h1>
        <p className="lede" style={{ marginTop: 12, marginInline: 'auto' }}>
          The page you're looking for moved or never existed. Try the navigation above.
        </p>
      </div>
    </main>
  );
}

export default function App() {
  const location = useLocation();
  return (
    <>
      <AmbientBackground />
      <ScrollToTop />
      <Navbar />
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/"         element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/work"     element={<WorkPage />} />
          <Route path="/about"    element={<AboutPage />} />
          <Route path="/contact"  element={<ContactPage />} />
          <Route path="*"         element={<NotFound />} />
        </Routes>
      </AnimatePresence>
      <Footer />
    </>
  );
}
